import React, { useState, useRef, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import { Carousel } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'

import Image from '../ui/Image/Image'
import useIsMobile from '../../hooks/useIsMobile'
import { getImageUrl } from '../../utils'

import styles from './EventsModal.module.scss'
// import LeftArrow from '../../assets/images/leftArrow.svg'
// import RightArrow from '../../assets/images/rightArrow.svg'
import arrow from '../../assets/images/arrow.svg'
import Close from '../../assets/images/close.svg'

const EventsModal = ({ open, data, setOpen }) => {
  const { eventfilter, image } = data
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [imageWidth, setImageWidth] = useState(0)
  const imageRef = useRef()
  const thumbnailRef = useRef(null)
  const isMobile = useIsMobile()

  const updateImageWidth = useCallback(() => {
    if (imageRef.current) {
      setImageWidth(imageRef.current.clientWidth)
    }
    setTimeout(() => {
      if (thumbnailRef.current) {
        thumbnailRef.current.scrollIntoView({
          behavior: 'smooth',
          inline: 'nearest',
        })
      }
    }, 0)
  }, [selectedIndex])

  useEffect(() => {
    if (imageRef.current) {
      if (imageRef.current.complete) {
        setTimeout(updateImageWidth, 0)
      } else {
        imageRef.current.addEventListener('load', updateImageWidth)
      }
    }
    return () => {
      if (imageRef.current) {
        imageRef.current.removeEventListener('load', updateImageWidth)
      }
    }
  }, [selectedIndex, updateImageWidth])

  const handleSelect = (index) => {
    setSelectedIndex(index)
  }

  const handlePrev = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? image.length - 1 : prevIndex - 1
    )
  }

  const handleNext = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === image.length - 1 ? 0 : prevIndex + 1
    )
  }

  const handleClose = () => setOpen()

  return (
    <>
      <Modal
        show={open}
        onHide={() => setOpen()}
        centered
        dialogClassName={styles['center-modal']}
        contentClassName={styles['center-modal-content']}
      >
        <div
          className={classNames(
            styles['top-container'],
            'flex justify-between h-auto items-center'
          )}
        >
          <div className={classNames('flex gap-2 md:gap-4 items-center')}>
            <div className={styles['event-name']}>{eventfilter?.label}</div>
            {/* {image?.length > 0 && (
              <div className={classNames(styles['image-name'])}>
                {image[selectedIndex]?.name}
              </div>
            )} */}
          </div>
          <img
            src={Close}
            alt="Close"
            className={classNames(
              'object-none cursor-pointer',
              styles['close-icon']
            )}
            onClick={handleClose}
          />
        </div>
        <Carousel
          activeIndex={selectedIndex}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
          interval={null}
          className={classNames('grow', styles['carousel-container'])}
          slide={false}
        >
          {image?.map((item, index) => (
            <Carousel.Item key={'carousel' + item?.id}>
              <Image
                className={classNames('d-block', styles['slide-image'])}
                src={getImageUrl(item)}
                alt={item.alternativeText}
                ref={index === selectedIndex ? imageRef : null}
                onLoad={updateImageWidth}
              />
            </Carousel.Item>
          ))}

          <img
            alt="left arrow"
            src={arrow}
            onClick={handlePrev}
            className={classNames('rotate180', styles['left-arrow'])}
          />
          <img
            alt="right arrow"
            src={arrow}
            onClick={handleNext}
            className={styles['right-arrow']}
          />
        </Carousel>

        <div
          className={classNames('flex', styles['thumbnail-wrapper'])}
          style={{ width: isMobile ? '100%' : imageWidth }}
        >
          {image?.map((item, index) => (
            <div
              key={item?.id}
              className={classNames(styles['thumbnail-element'])}
            >
              <Image
                src={getImageUrl(item?.formats?.thumbnail)}
                alt={item?.alternativeText}
                onClick={() => handleSelect(index)}
                className={classNames(
                  'cursor-pointer',
                  styles['thumbnail-image'],
                  index === selectedIndex
                    ? styles['active']
                    : styles['inactive']
                )}
                ref={index === selectedIndex ? thumbnailRef : null}
              />
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}

export default EventsModal
